export default __webpack_public_path__ + "static/media/obama.3d0cb3d5.svg";